var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlay)?_c('div',[_c('div',{ref:"overlay",staticClass:"home__overlay"},[_c('div',{staticClass:"home__white_dot",on:{"click":_vm.handleDotClick}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }